/** The refusals of a reel create that the Studio shows in its own way (design a5, a6). */
export type ReelRefusalCode =
  | 'AI_REELS_UNAVAILABLE'
  | 'M24_LIMIT_FEATURE'
  | 'M24_LIMIT_QUOTA'
  // 429: the AI budget of Free and trial workspaces is spent this month (the upgrade prompt opens).
  | 'M24_AI_BUDGET_FREE_EXHAUSTED';

const CODES: ReadonlyArray<string> = [
  'AI_REELS_UNAVAILABLE',
  'M24_LIMIT_FEATURE',
  'M24_LIMIT_QUOTA',
  'M24_AI_BUDGET_FREE_EXHAUSTED',
];

/**
 * Reads the refusal code of a failed create. `customBaseQuery` puts the REST `cause` on the error
 * as `m24Limit`. Null for any other error.
 */
export function reelRefusalCode(error: unknown): ReelRefusalCode | null {
  if (typeof error !== 'object' || error === null) {
    return null;
  }
  const cause = (error as { m24Limit?: unknown }).m24Limit;
  if (typeof cause !== 'object' || cause === null) {
    return null;
  }
  const { code } = cause as { code?: unknown };
  return typeof code === 'string' && CODES.includes(code) ? (code as ReelRefusalCode) : null;
}

/** The 409 codes of approve, reject and regenerate (`ReelConflictCause`). */
export type ReelConflictCode = 'REEL_NOT_READY' | 'REEL_NOT_REGENERATABLE';

const CONFLICT_CODES: ReadonlyArray<string> = ['REEL_NOT_READY', 'REEL_NOT_REGENERATABLE'];

/** Reads the 409 code of a failed reel action. Null for any other error. */
export function reelConflictCode(error: unknown): ReelConflictCode | null {
  if (typeof error !== 'object' || error === null) {
    return null;
  }
  const cause = (error as { m24Limit?: unknown }).m24Limit;
  if (typeof cause !== 'object' || cause === null) {
    return null;
  }
  const { code } = cause as { code?: unknown };
  return typeof code === 'string' && CONFLICT_CODES.includes(code) ? (code as ReelConflictCode) : null;
}

/** The `resetsAt` of a 402 quota refusal, when the error carries one. */
export function reelRefusalResetsAt(error: unknown): string | null {
  if (typeof error !== 'object' || error === null) {
    return null;
  }
  const cause = (error as { m24Limit?: { resetsAt?: unknown } }).m24Limit;
  return typeof cause?.resetsAt === 'string' ? cause.resetsAt : null;
}

/** The 400 causes of a reel create for a catalog row that has no usable master (D2). */
export type ReelSongRefusal = 'M24_NO_MASTER' | 'M24_MASTER_PROCESSING';

const SONG_REASONS: ReadonlyArray<string> = ['M24_NO_MASTER', 'M24_MASTER_PROCESSING'];

/** Reads the song refusal of a failed create (`cause.reason`). Null for any other error. */
export function reelSongRefusal(error: unknown): ReelSongRefusal | null {
  if (typeof error !== 'object' || error === null) {
    return null;
  }
  const cause = (error as { m24Limit?: unknown }).m24Limit;
  if (typeof cause !== 'object' || cause === null) {
    return null;
  }
  const { reason } = cause as { reason?: unknown };
  return typeof reason === 'string' && SONG_REASONS.includes(reason) ? (reason as ReelSongRefusal) : null;
}
